import { useEffect, useState } from "react";
import { api } from "../../lib/api";
import { useBrand } from "../../contexts/BrandContext";
import SEO from "../../components/SEO";

export default function About() {
  const { mode, brand } = useBrand();
  const [page, setPage] = useState(null);

  useEffect(() => {
    const slug = mode === "brand" ? brand.slug : "_all";
    api.get(`/pages/about/${slug}`).then((r) => setPage(r.data));
  }, [mode, brand]);

  return (
    <div className="fade-in-up" data-testid="about-page">
      <SEO title="Hakkımızda" />
      <div className="border-b border-white/10 py-16 bg-gradient-to-b from-[#0A0A0A] to-[#050505]">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-xs uppercase tracking-[0.3em] text-zinc-500 mb-3">Hikayemiz</div>
          <h1 className="font-display text-4xl sm:text-5xl tracking-tighter">Hakkımızda</h1>
        </div>
      </div>

      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="text-zinc-300 leading-relaxed whitespace-pre-wrap text-base" data-testid="about-content">
          {page?.content ||
            (mode === "brand"
              ? `${brand.name}, Türkiye'de Noon Foto güvencesiyle distribüte edilmektedir. Profesyonel fotoğraf ekipmanlarında orijinal ürün, garanti ve yetkili servis avantajı sunuyoruz.`
              : "Noon Foto, Türkiye'nin önde gelen profesyonel fotoğraf ekipmanları distribütörüdür. Dünya çapında tanınmış markaların resmi temsilciliğini yapmakta, müşterilerimize orijinal ürün, tam garanti ve yetkili teknik servis hizmeti sunmaktayız.")}
        </div>
      </div>
    </div>
  );
}
